import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence, indexedDBLocalPersistence, initializeAuth, } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import config from '../../config.json';
import { getFirestore } from 'firebase/firestore';
import { Capacitor } from '@capacitor/core';
import { getApp } from 'firebase/app';

const app = initializeApp({
    apiKey: config.FIREBASE_API_KEY,
    authDomain: config.FIREBASE_AUTH_DOMAIN,
    projectId: config.FIREBASE_PROJECT_ID,
    storageBucket: config.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: config.FIREBASE_MESSAGING_SENDER_ID,
    appId: config.FIREBASE_APP_ID,
    measurementId: config.FIREBASE_MEASUREMENT_ID
});

export const firebaseAuth = async () => {
    if (Capacitor.isNativePlatform()) {
        return initializeAuth(getApp(), {
            persistence: indexedDBLocalPersistence,
        });
    } else {
        return getAuth();
    }
};
export const db = getFirestore(app);

// Set persistence to LOCAL
async function setPers() {
    const auth = await firebaseAuth();
    if (Capacitor.isNativePlatform()) {
        setPersistence(auth, indexedDBLocalPersistence)
            .then(() => {
                console.log('Firebase persistence set to LOCAL');
            })
            .catch((error) => {
                console.error('Error setting persistence:', error);
            });
    } else {
        setPersistence(auth, browserLocalPersistence)
            .then(() => {
                console.log('Firebase persistence set to LOCAL');
            })
            .catch((error) => {
                console.error('Error setting persistence:', error);
            });
    }
}

setPers();

export const firebaseAnalytics = getAnalytics(app);
export default app;
